module.exports = __webpack_public_path__ + "img/3x3basketball-dark.d32c311b.svg";